import { Link } from "react-router-dom";
import cardFlipStyles from "components/homepage-pools-list/card-flip.module.scss";
import PoolItemHomepage from "components/homepage-pools-list/homepage-pool-item";
import { Pool } from "interfaces/pool";

interface Props {
  poolPageLink: string;
  pool: Pool;
  handleSetSelectedEntry: any;
  isAllowedToBet: () => Promise<boolean>;
  contestEntryId?: string;
}

const FrontCard = ({
                     poolPageLink,
                     pool,
                     handleSetSelectedEntry,
                     isAllowedToBet,
                     contestEntryId
                   }: Props) => {

  return (
    <Link
      id="a-PoolItem-clickPoolItem"
      to={poolPageLink}
      style={{
        textDecoration: "none",
        color: "unset",
      }}
      className={cardFlipStyles.cardFlipFront}
    >
      <PoolItemHomepage
        key={pool.id}
        pool={pool}
        setSelectedEntry={handleSetSelectedEntry}
        showCountDownClock
        isAllowedToBet={isAllowedToBet}
        contestEntryId={contestEntryId}
      />
    </Link>
  );
};

export default FrontCard;
